import React from 'react';
import {Grid, IconButton, ToggleButton} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';

export const MapToolbar = props => {
  // const setToggle = () => console.log("TOGGLE");
  // const toggle = props.renderView;
  const [toggle, setToggle] = React.useState(props.renderView);
  const handleClick = e => {
    const name = e.currentTarget.name;
    if (name === 'lock-all') {
      props.onLock();
    } else if (name === 'unlock-all') {
      props.onUnlock();
    } else if (name === 'reset-locations') {
      props.onReset();
    }
  };

  const handleToggle = e => {
    const value = !toggle;
    setToggle(value);
    // if (toggle) {
    props.onToggle(!value);
    // }
  };

  //     useEffect(() => {
  //          setToggle(false);
  //         return () => {
  // setToggle(false)        }
  //     }, [])

  return (
    <Grid
      style={{
        margin: '15px 0px 0px 0px',
        padding: '4px',
        backgroundColor: 'white',
        borderRadius: '10px'
      }}
      container
      direction='row'
      justifyContent='center'
      alignItems='center'>
      <IconButton
        name='lock-all'
        disabled={toggle}
        size='large'
        color='primary'
        onClick={e => handleClick(e)}>
        <LockIcon />
      </IconButton>
      <IconButton
        name='unlock-all'
        disabled={toggle}
        size='large'
        onClick={e => handleClick(e)}>
        <LockOpenIcon />
      </IconButton>
      <IconButton
        name='reset-locations'
        disabled={toggle}
        color='primary'
        onClick={e => handleClick(e)}>
        <ReplayCircleFilledIcon />
      </IconButton>

      <ToggleButton
        value='check'
        selected={toggle}
        onChange={e => handleToggle(e)}>
        <CenterFocusStrongIcon />
      </ToggleButton>
    </Grid>
  );
};
